import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative overflow-hidden',
    wrap: 'relative flex h-111 flex-col justify-between px-4 pt-25 pb-6 lg:container lg:h-165 lg:justify-center lg:pt-50',
    title:
      'font-rf-tone pr-3 text-[40px] leading-[1.2] font-semibold lg:mb-4 lg:text-center lg:text-[68px]',
    description:
      'mt-2 text-base leading-[1.2] lg:m-auto lg:w-150 lg:text-center lg:text-xl',
    video: 'absolute top-0 left-0 h-full w-full object-cover',
    imageContainer: 'absolute top-0 left-0 h-full w-full',
    image: 'absolute top-0 left-0 h-full w-full object-cover',
    body: 'relative',
    breadcrumbsWrapper: 'relative z-2 lg:absolute lg:top-48',
    breadcrumbs: '',
    link: 'relative inline-flex min-w-18.25 flex-none cursor-pointer items-center gap-3 overflow-hidden rounded-[100px] px-1 py-1 pr-5 xl:min-w-69 xl:gap-4 xl:pr-8',
    linkIconWrap:
      'relative flex h-12.5 w-12.5 items-center justify-center rounded-full xl:h-18 xl:w-18',
    linkIcon: 'h-auto w-full',
    linkTitle: 'relative text-left whitespace-nowrap xl:text-lg',
    linkList:
      'scrollbar-hidden mt-6 -mr-3 -ml-3 flex gap-2 overflow-x-auto pr-3 pl-3 lg:justify-center xl:mt-21',
    linkBack:
      'absolute top-0 right-0 bottom-0 left-0 rounded-[100px] blur-[3px] md:blur-[0]'
  },
  variants: {
    mode: {
      light: {
        title: 'text-black',
        description: 'text-black'
      },
      dark: {
        breadcrumbs: 'text-white',
        title: 'text-white',
        description: 'text-white',
        linkIconWrap: 'bg-white',
        linkTitle: 'text-white',
        linkBack: 'bg-[#E7DFDB99]'
      }
    }
  }
});
